import { login } from "../../services/Auth";
import { LOGIN_SUCCESS, LOGIN_ERROR } from "../slices/authenticationSlice";

export const loginAction = (authData) => async (dispatch) => {
    const res = await login(authData);
    console.log("login res", res);
    if (res?.accessToken) {
        localStorage.setItem("token", res?.data?.token);
        localStorage.setItem("accessToken", res?.accessToken);
        localStorage.setItem("refreshToken", res?.refreshToken);
        localStorage.setItem("email", res?.data?.email);
        localStorage.setItem("mobile", res?.data?.mobile);
        localStorage.setItem("userType", res?.data?.userType);
        localStorage.setItem("selectedUserType", res?.data?.selectedUserType);
        localStorage.setItem("userId", res?.data?._id);
        localStorage.setItem("username", res?.data?.firstName);
        localStorage.setItem("login", true);
        localStorage.setItem("inviteCode", res?.data?.inviteCode);
        localStorage.setItem("vehicleId", res?.data?.userVehicle[0] || "");
        dispatch(LOGIN_SUCCESS(res));
        return res;
    } else {
        dispatch(LOGIN_ERROR("Error"));
        return res;
    }
};
